import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';

import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW1405Module } from '../kymw1405/kymw1405.module';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW1404Component } from './kymw1404.component';
import { GetNominationGoodsDataService } from './api-services/get-nomination-goods-data.service';
import { GetSellingAreaService } from './api-services/get-selling-area.service';


/**
 * 掲載候補商品リスト画面 モジュール設定クラス
 *
 * @export KYMW1404Module
 * @class KYMW1404Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjInputModule,
    WjGridFilterModule,
    KYMW1405Module
  ],
  declarations: [
    KYMW1404Component,
  ],
  providers: [
    GetNominationGoodsDataService,
    GetSellingAreaService,
  ],
})
export class KYMW1404Module {
}
